import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const settingsService = {
    async load(): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/settings/load`);
            return response.data;
        } catch (error) {
            console.error("Error load settings", error);
            throw error;
        }
    },

    async save(setting: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/settings/save`,
                setting
            );
            return response.data;
        } catch (error) {
            console.error("Error save setting", error);
            throw error;
        }
    },
}

export default settingsService;